import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const QuestionMarkSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default QuestionMarkSVG;
